import { ChangeDetectorRef, Component, OnInit, Renderer2, ViewChild, effect, inject, signal } from '@angular/core';
import Clarity from '@microsoft/clarity';
import { PlatformService } from './services/platform.service';
import { RegisterIconsService } from './services/register-icons.service';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { MenusService } from './services/menus.service';
import { BuscaService } from './services/busca.service';
import { ApiUsuarioService } from './services/api-usuario.service';
import { Dialog } from '@angular/cdk/dialog';
import { ApiS3Service } from './services/api-s3.service';
import { ExtensaoService } from './services/extensao.service';
import { menuCotacao_new, menuPrincipal, menuReduzido } from './utils/menus-apice';
import { environment } from 'src/environments/environment';
import { ServiceWorkerService } from './services/service-worker.service';
import { ConnectionService } from 'ng-connection-service';
import { ControllerStatusService } from './services/controller-status.service';
import { ApiInterfaceService } from 'src/app/services/api/api-interface.service';
import { debounceTime, filter, map } from 'rxjs/operators';
import { ToolBarActionsService } from 'src/app/services/tool-bar-actions.service';
import { trigger, style, animate, transition, state } from '@angular/animations';
import { pathToRegexp } from 'path-to-regexp';
import { fromEvent } from 'rxjs';
import { UtilsService } from './services/utils.service';
import { AlertConfirmService } from './services/alert-confirm.service';
import { HttpClient } from '@angular/common/http';
import { TokenInterceptorService } from './services/token-interceptor.service';
import { ModalIntroComponent } from './components/modal-intro/modal-intro.component';
import { ModalIntroService } from './components/modal-intro/modal-intro.service';
import { MatSnackBar } from '@angular/material/snack-bar';

const CONVERSU_SCRIPT_TAG_ID = 'conversu-plugin-id';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    animations: [
        trigger('animationRotate', [
            state('close', style({ transform: 'rotate(0)' })),
            state('open', style({ transform: 'rotate(-180deg)' })),
            transition('open <=> close', animate('400ms ease-in-out')),
        ]),
        trigger('animationShowHide', [
            state('close', style({ height: '0px', overflow: 'hidden' })),
            state('open', style({ height: '*' })),
            transition('open <=> close', animate('400ms ease-in-out')),
        ])
    ],
    standalone: false
})
export class AppComponent implements OnInit {

    protected environment = environment

    @ViewChild('toolBarActions') toolBarActions: any;
    isRoot: boolean = false;
    isSuperRoot: boolean = false;
    title = 'Ápice';
    sessao;
    validacaoCorretora;

    contrato = false
    termoUso = false
    mostrarTermos = false
    privacidade = false

    public listaReduzida = menuReduzido;
    public listaMenusCotacao = menuCotacao_new;
    public listaMenuPrincipal = menuPrincipal;

    private jaCarregouModalIntro = false;

    menusCotacao = this.listaMenusCotacao;
    menuPrincipal = signal<any>(this.listaMenuPrincipal);

    loaderTermos = false
    payload = {
        "contrato": "https://docs.agger.com.br/Contrato_Agger.pdf",
        "termosUso": "https://docs.agger.com.br/Termo_Uso.pdf",
        "politicasPrivacidade": "https://docs.agger.com.br/Politica_Privacidade.pdf"
    }

    enteredButton = false;
    isMatMenuOpen = false;
    prevButtonTrigger;
    formaPagamento;

    menuContraido: boolean = false;
    effectLogo: boolean = false;
    menuToggle: boolean = false;
    autenticado: boolean = false;
    fezCheckStatusSistema: boolean = false;
    callUpdateServicesInfos: boolean = false;
    protected showWarning: boolean = true;
    protected showWarningMobile: boolean = false;
    internetCaiu = false;
    buscaAtiva: boolean = false;
    recolheItensMenu: boolean = false;
    escondeIconesMenu: boolean = false;
    //mostrar/ocultar filtro
    filtro = {
        open: false,
        page: '',
        data: false
    };

    version = environment.version;

    iconsMulti = [
        'cards-heart',
        'arrow-left',
        'arrow-back',
        'close',
        'briefcase-edit',
        'barcode',
        'credit-card-outline',
        'bank',
        'cash-usd',
        'file-pdf',
        'search-web',
        'alert-circle-outline',
        'calculator',
        'home',
        'content-copy',
        'content-save',
        'car-info',
        'paperclip',
        'detail',
        'delete',
        'dots-vertical',
        'pencil',
        'file-document-outline',
        'file-document-edit',
        'file-eye',
        'file-multiple',
        'text-box-plus',
        'folder-image',
        'handshake',
        'chevron-left',
        'chevron-right',
        'chevron-down',
        'checkbox-marked-circle',
        'plus',
        'progress-clock',
        'check-circle-outline',
        'check-circle',
        'swap-horizontal',
        'circle-off-outline',
        'circle-outline',
        'content-save-outline',
        'negocio-fechado',
        'negocio-fechado-home',
        'negocio-perdido',
        'chevron-double-up',
        'negocio-nao-fechado',
        'cash-usd-outline',
        'thumbs-up-down',
        'chevron-double-up',
        'thumb-down-outline',
        'thumb-down',
        'thumb-up',
        'human-male',
        'human-female',
        'cards-heart',
        'factory',
        'phone',
        'phone-outline',
        'whatsapp',
        'email',
        'video',
        'youtube',
        'truck',
        'pdf-box',
        'editando',
        'domain',
        'view-list',
        'view-dashboard',
        'chart-areaspline-variant',
        'tools',
        'exit-to-app',
        'message-question-outline',
        'trash-can-outline',
        'check',
        'clock-outline',
        'robot-confused-outline',
        'cogs',
        'cartao-porto',
        'cartao-porto-black',
        'close-oferta',
        'porto-logo',
        'porto-logo-txt',
        'porto-logo-sem-txt',
        'calendar-sync',
        'vida-global',
        'account-injury',
        'bag-suitcase',
        'heart-pulse',
        'car',
        'security',
        'chevron-up',
        'car-wifi',
        'house-car',
        'bicycle',
        'smartphone',
        'hexagon-multiple',
        'key-chain-variant',
        'shield-edit',
        'key-chain-variant',
        'filter',
        'arrow-right-alt',
        'content-save',
        'brightness-percent',
        'moedas',
        'hand-coin',
        'open_in_new',
        'printer-edit',
        'star',
        'star-outline',
        'teamviewer',
        'email-outline'
    ];

    status;
    toolBarActionsConfigs;
    rotaAtual;
    controleEffect = false;

    private currentInnerWidth = window.innerWidth;

    protected readonly CONVERSU = environment.conversu;
    private cdr = inject(ChangeDetectorRef);

    constructor(
        public apiUsuario: ApiUsuarioService,
        public apiS3: ApiS3Service,
        private router: Router,
        private api: ApiInterfaceService,
        public platformService: PlatformService,
        public icons: RegisterIconsService,
        private menusService: MenusService,
        private buscaService: BuscaService,
        public extensaoService: ExtensaoService,
        private dialog: Dialog,
        public snackBar: MatSnackBar,
        public sw: ServiceWorkerService,
        public controllerStatus: ControllerStatusService,
        private connectionService: ConnectionService,
        private ren: Renderer2,
        private toolBarActionsService: ToolBarActionsService,
        protected utilsService: UtilsService,
        private alertConfirmService: AlertConfirmService,
        private http: HttpClient,
        public tokenInterceptorService: TokenInterceptorService,
        private modalIntroService: ModalIntroService,
    ) {
        icons.registerIcons(['alert','backup-restore', 'menu', 'monitor-dashboard', 'account-group', 'business', 'menu-tarefas', 'account', 'swap-horizontal',
            'calculator', 'office-building', 'cog', 'lifebuoy', 'plus', 'briefcase', 'credit-card-multiple', 'alert-octagram',
            'logout-variant', 'funnel', 'cash-multiple', 'calendar-text-outline', 'tune', 'file-download-outline', 'wrench',
            'file-document', 'account-multiple', 'city', 'city-variant', 'source-branch', 'format-list-checks', 'motorbike', 'car-hatchback', 'information-outline', 'close', 'currency-usd-off', 'corretor_digital2', 'domain', 'tag', 'shield-edit',
            'autorenew', 'thumbs-up-down-fill', 'drag-variant', 'hand-pointing-right', 'text-box', 'account-outline', 'email-open-outline', 'currency-usd',
            'shield-outline', 'timer-sand-empty', 'car-outline', 'logout-outline', 'eye', 'lock', 'printer', 'arrow-left-circle', 'arrow-right-circle', 'pencil-square', 'remove', 'arrow-u-left-top', 'card-account-details', 'card-account-details-outline',
            'map-marker', 'wall', 'shield-home', 'key', 'home-city', 'home-group', 'gender-male-female', 'handshake', 'account-tie-woman', 'account-tie', 'train-car', 'seat-passenger', 'home-map-marker', 'map-marker-path', 'bag-personal-tag', 'bike',
            'motorbike-electric', 'shield-key', 'earth', 'printer-pos', 'plus-circle', 'clock', 'alert-error-modal', 'chevron-double-down', 'format-list-bulleted-square', 'atendimento', 'agger-icon', 'user', 'star-outline', 'star', 'alert-circle', 'arrow-all',
            'timer-alert', 'cota-premio', 'async-alt', 'aggilizador', 'itau', 'porto-seguro', 'sync', 'magnify', 'microsoft-excel','timer-alert', 'cota-premio', 'async-alt', 'aggilizador', 'itau', 'porto-seguro', 'sync', 'school', 'magnify', 'microsoft-excel', 'smiling', 'new', 'pdf', 'chatbot-speech-bubble', 'shield-check', 'receipt', 'calendario-de-folha-de-pagamento', 'shield-sync', 'vida-solid', 'residencial', 'empresarial', 'condominio', ...this.iconsMulti]);


        this.connectionService.monitor().subscribe(currentState => {
            if (!currentState.hasInternetAccess && !currentState.hasNetworkConnection) {
                this.utilsService.alertCustom({ txt: 'Sem conexão!', duration: 6000 });
                this.internetCaiu = true;
            }
            else if (this.internetCaiu) {
                this.utilsService.alertCustom({ txt: 'Conectado novamente!', duration: 6000 });
                this.internetCaiu = false;
            }
            this.status = !!status;
        });

        effect(() => {
            if (this.apiUsuario.isAgger() && !this.controleEffect) {
                this.controllerStatus.isAggerPayment = true;
                this.controleEffect = true;
            } else if (this.apiUsuario.grupoPermissoesUsuario() && apiUsuario.atualizouPermissoes()) {
                this.apiUsuario.atualizouPermissoes.set(false);
                let copyMenu = JSON.parse(JSON.stringify(this.menuPrincipal()));
                this.menuPrincipal.set(copyMenu);
                setTimeout(() => {
                    if (this.validacaoCorretora?.prazoHoras < 0) {
                        this.menuPrincipal.set(this.listaReduzida);
                    } else {
                        this.menuPrincipal.set(this.listaMenuPrincipal);
                    }
                }, 1);
            }
        });

    }

    ngOnInit() {
        Clarity.init('s1eeuywcyw');

        this.listenWindowResizeEvent();

        this.apiUsuario.atualizaKeysPagamento();
        //observa mudanças de abertura/fechamento no menu mobile
        this.menusService.toggleMenu().subscribe(ret => {
            this.menuToggle = ret
            if (this.menuToggle) this.menusService.setMenuFilter((prev) => {
                return { ...prev, open: false };
            })
        });
        //observa mudança se usuário esta autenticado ou não no sistema
        this.apiUsuario.autenticado.asObservable().subscribe(async ret => {
            this.autenticado = ret;

            if (this.autenticado) {
                try {
                    const email = this.apiUsuario.getCredenciais()?.email;

                    const identifier = email
                      ? this.apiUsuario.encryptData(email)
                      : `guest-${Math.random().toString(36).substring(7)}`;

                    Clarity.identify(identifier);
                } catch (e) {
                    Clarity.identify(`guest-${Math.random().toString(36).substring(7)}`);
                }
            } else {
                Clarity.identify(`guest-${Math.random().toString(36).substring(7)}`);
            }

            if (this.autenticado) {
                if (this.apiUsuario.getCredenciais().admin) {
                    if (this.apiUsuario.getCredenciais().root == 3) {
                        this.isSuperRoot = true;
                        this.isRoot = true;
                    } else if (this.apiUsuario.getCredenciais().root) {
                        this.isRoot = true;
                    }
                    this.menuPrincipal.set(this.listaMenuPrincipal);
                    this.menusCotacao = this.listaMenusCotacao;
                }

                this.sessao = this.apiUsuario.getCredenciais();
                this.toolBarActionsConfigs = await this.toolBarActionsService.getToolBarActionsConfigs();
                this.validacaoCorretora = this.apiUsuario.verificaLicenca();
                if (this.validacaoCorretora?.prazoHoras < 0) {
                    this.menuPrincipal.set(this.listaReduzida);
                    this.menusCotacao = [];
                }

                if (!this.callUpdateServicesInfos) {
                    this.callUpdateServicesInfos = true;
                }
                if (!this.fezCheckStatusSistema) {
                    this.fezCheckStatusSistema = true;
                    this.controllerStatus.buscaSeguradoras();
                    let count = 0;
                    let interval2 = setInterval(() => {
                        this.atualizaStatusExtensao();
                        this.verificaRecolheItensMenu();
                        count++;
                        if (count > 120000 || this.extensaoInstalada) {
                            clearInterval(interval2);
                        }
                    }, 100);
                }

                await this.openModalVideoIntro();
            }
        });

        //oobserva mudança
        this.apiUsuario.exibirTermos.asObservable().subscribe(t => {
            this.mostrarTermos = t
        })

        if (this.apiUsuario.isAgger) this.controllerStatus.isAggerPayment = true;
        this.menusService.menuFilter().subscribe(ret => {
            if (this.filtro.open) this.closeMenuToggle();
        });

        this.menusService.buscaAberta.subscribe(ret => {
            this.atualizaBuscaAberta(ret);
        });

        this.toolBarActionsService.setaTituloEmitter.subscribe(novoTitulo => {
            if (novoTitulo) this.setaTituloPaginaAtual(novoTitulo);
        });

        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe(() => {
            let url = this.router.routerState.snapshot.url
            this.rotaAtual = url;
            this.menuContraido = false;
            this.showWarningMobile = this.utilsService.isMobileDevice();
            this.atualizaBuscaAberta(false);
            this.buscaService.enviaFecharBusca(this.buscaAtiva);
            this.menusService.setMenuDesktop(this.menuContraido);
            this.setaMenuComoAtivo();
            if (this.toolBarActions) this.toolBarActions.ngOnInit();
            let invervalCheca;
            let count = 0;


                invervalCheca = setInterval(() => {
                    let elemChat: any = document.querySelector('#md-app-widget');
                    if (elemChat) {
                        clearInterval(invervalCheca);
                        let styles = elemChat.attributes.style.value;
                        if (/visible/gm.test(styles)) {
                            elemChat.attributes.style.value = elemChat.attributes.style.value.replace('visible', 'hidden');
                        } else if (!/visibility/gm.test(styles)) {
                            elemChat.attributes.style.value = "visibility: hidden;";
                        }
                    }
                    count++;
                    if (count > 100) {
                        clearInterval(invervalCheca);
                    }
                }, 10);

        });


        this.router.events.pipe(
            filter(event => event instanceof NavigationStart)
        ).subscribe((data: any) => {
            if (data.url != '/login' && !/\/redefinir-senha/g.test(data.url) && !/\/criar-senha/g.test(data.url)
                && data.url != '/recuperar-senha' && data.url != '/criar-conta' && data.url != '/confirmacao'
                && data.url != '/ens' && !/^\/registro-administrador\/[^\/]+$/.test(data.url)
            ) {
                this.apiUsuario.pathHistory = data.url;
            }
        });
        /**
         * Chama service-work para verificar novos builds
         */
        setTimeout(() => {
            this.sw.checkUpdate();
        }, 60000)

    }

    async aceitarTermos() {
        this.loaderTermos = true

        try {
            await this.apiUsuario.aceitaTermos(this.payload)

            await this.tokenInterceptorService.refreshToken().toPromise();

            this.mostrarTermos = false
            this.loaderTermos = false
            this.termoUso = false
            this.contrato = false
            this.privacidade = false
        } catch (err) {
            this.utilsService.alertCustom({ txt: 'Não foi possível concluir está etapa.', alertType: 'ERROR' })
            this.loaderTermos = false
        }


    }

    private openModalVideoIntro = async () => {
        if (this.jaCarregouModalIntro) return;

        if (localStorage.getItem('escondeModalIntro') !== 'true') {
            this.jaCarregouModalIntro = true;

            const data = await this.modalIntroService.researchModal();

            if (data == null) return;

            setTimeout(() => {
                this.dialog.open(ModalIntroComponent, {
                    width: '80%', height: '80%',
                    data: data
                });
            }, 1500);
        }
    }

    abrirPerfil() {
        this.router.navigateByUrl('/perfil-usuario');
        this.closeMenuToggle();
    }

    extensaoInstalada: boolean = false;
    atualizaStatusExtensao() {
        let input: any = document.querySelector('#bExtensaoExterno');
        if (input && input.value == 'mudei') {
            this.extensaoInstalada = true;
            this.extensaoService.setStatusExtensao(true);
        }
    }

    //controller menu
    alternaMenu() {
        this.menuContraido = !this.menuContraido;
        this.effectLogo = !this.menuContraido;
        if (this.platformService.virtualDeviceType == 'desktop') {
            this.menusService.setMenuDesktop(this.menuContraido);
        }
    }

    //fecha menu mobile backdrop
    closeMenuToggle() {
        this.menuToggle = false;
        this.menusService.setToggleMenu(false);
    }

    //navega para a rota e também deixa a opção do menu ativa
    rotaLinkMenu(rota, index, j?) {
        if (rota) {
            if (rota === '/online' && this.platformService.deviceType != 'desktop') {
                return this.utilsService.alertCustom({ txt: 'Painel do Online ainda não disponível para dispositivos móveis.', duration: 6000 });
            }
            if (rota === '/suporte') {
                window.open(this.apiUsuario.urlCentral, "_blank");
            }
            if (this.menuPrincipal()[index].subList.length > 0) {
                for (let [s, sub] of Object.entries(this.menuPrincipal()[index].subList)) {
                    if (j == s) {
                        this.menuPrincipal()[index].subList[j].active = !(sub as any).active;
                    } else {
                        this.menuPrincipal()[index].subList[s].active = false;
                    }
                }
                for (let i = 0; i < this.menuPrincipal().length; i++) { if (this.menuPrincipal()[i].active) { this.menuPrincipal()[i].active = false; } }
                this.menuPrincipal()[index].open = false;
                this.menuPrincipal()[index].active = true;
            } else {
                for (let [m, menu] of Object.entries(this.menuPrincipal() as any[])) {
                    if (m == index) {
                        this.menuPrincipal()[index].active = true;
                    } else {
                        this.menuPrincipal()[m].active = false;
                    }
                    if (menu.subList.length > 0) { for (let i = 0; i < menu.subList.length; i++) { menu.subList[i].active = false; } }
                }

            }

            if (this.menuPrincipal()[index]?.external) {
                window.open(rota, '_blank');
            } else {
                this.router.navigateByUrl(rota).finally(() => {
                    if (this.platformService.virtualDeviceType == 'phone' || this.platformService.virtualDeviceType == 'tablet') {
                        this.closeMenuToggle();
                    }
                })
            }
            // this.apiS3.setStateMenuPerfil(false);
        }
    }

    receiveRotaLinkMenuMobileEvent = (menuItem: { url: any, index: any }) => {
        this.rotaLinkMenu(menuItem.url, menuItem.index);
    }

    //abre opções do menu
    toggleSubMenu(index) {
        for (let [i, menu] of Object.entries(this.menuPrincipal() as any[])) {
            if (index == i) {
                this.menuPrincipal()[index].open = !menu.open
            } else {
                this.menuPrincipal()[i].open = false
            }
        }

        for (let i = 0; i < this.menuPrincipal().length; i++) {
            if (this.menuPrincipal()[i].subList.length > 0) {
                for (let j = 0; j < this.menuPrincipal()[i].subList.length; j++) {
                    if (this.router.url == this.menuPrincipal()[i].subList[j].url) {
                        this.menuPrincipal()[i].subList[j].active = true;
                    } else {
                        this.menuPrincipal()[i].subList[j].active = false;
                    }
                }
            }
        }

    }

    async loadAvatar() {
        if (!this.apiUsuario.avatar) {
            this.apiUsuario.avatar = await this.apiS3.loadAvatarUsuarioLogado();
        }
    }

    protected handleEsconderWarning() {
        this.showWarning = false;
    }

    observaRota() {
        this.router.events.forEach(e => {
            if (e instanceof NavigationEnd) {
                return e.url
            }
        });
    }

    menuEnter() {
        this.isMatMenuOpen = true;
    }

    menuLeave(trigger, button) {
        setTimeout(() => {
            if (!this.enteredButton) {
                this.isMatMenuOpen = false;
                trigger.closeMenu();
                this.ren.removeClass(button['_elementRef'].nativeElement, 'cdk-focused');
                this.ren.removeClass(button['_elementRef'].nativeElement, 'cdk-program-focused');
            } else {
                this.isMatMenuOpen = false;
            }
        }, 80)
    }

    buttonEnter(trigger) {
        setTimeout(() => {
            if (this.prevButtonTrigger && this.prevButtonTrigger != trigger) {
                this.prevButtonTrigger.closeMenu();
                this.prevButtonTrigger = trigger;
                trigger.openMenu();
            }
            else if (!this.isMatMenuOpen) {
                this.enteredButton = true;
                this.prevButtonTrigger = trigger
                trigger.openMenu()
            }
            else {
                this.enteredButton = true;
                this.prevButtonTrigger = trigger
            }
        })
    }

    changeStyle(menu) {
        menu.hovered = !menu.hovered;
    }

    buttonLeave(trigger, button) {
        setTimeout(() => {
            if (this.enteredButton && !this.isMatMenuOpen) {
                trigger.closeMenu();
                this.ren.removeClass(button['_elementRef'].nativeElement, 'cdk-focused');
                this.ren.removeClass(button['_elementRef'].nativeElement, 'cdk-program-focused');
            } if (!this.isMatMenuOpen) {
                trigger.closeMenu();
                this.ren.removeClass(button['_elementRef'].nativeElement, 'cdk-focused');
                this.ren.removeClass(button['_elementRef'].nativeElement, 'cdk-program-focused');
            } else {
                this.enteredButton = false;
            }
        }, 100)
    }

    setaMenuComoAtivo() {
        try {
            this.menuPrincipal().forEach(m => m.active = false);
            let menu = this.menuPrincipal().find(m => m.url === this.router.routerState.snapshot.url);
            if (menu) menu.active = true;
            else {
                this.menuPrincipal().forEach(m => {
                    let subMenu = m.subList.find(s => s.url === this.router.routerState.snapshot.url);
                    if (subMenu) m.active = true;
                });
            }
        } catch (error) {
            return false;
        }
    }

    goToCotacoes() {
        this.router.navigateByUrl('/cotacoes');
    }

    logout() {
        this.apiS3.avatarUsuarioLogado = null;
        this.apiUsuario.avatar = null;
        this.router.navigateByUrl('/login');
        this.closeMenuToggle();
        localStorage.setItem('pathRefer', '');
    }

    encontraTitulo() {
        try {
            if (this.rotaAtual) {
                let rota = this.encontraRota(this.rotaAtual);
                return this.toolBarActionsConfigs[rota]?.titulo ? this.toolBarActionsConfigs[rota].titulo : '';
            } else {
                return '';
            }
        } catch (error) {
            return '';
        }
    }

    encontraRota(rotaAtual) {
        return Object.keys(this.toolBarActionsConfigs).find((info) => this.verificaURL(rotaAtual, info));
    }

    atualizaBuscaAberta(ativa) {
        this.buscaAtiva = ativa;
        this.verificaRecolheItensMenu();
    }

    verificaURL(urlAtual, padrao) {
        try {
            if (padrao.includes('?')) {
                if (urlAtual.includes('?')) {
                    return padrao.split('?')[0] === urlAtual.split('?')[0];
                } else {
                    return false;
                }
            } else {
                const regexPattern = pathToRegexp(padrao);
                const correspondem = regexPattern.test(urlAtual);
                return correspondem;
            }
        } catch (error) {
            return false;
        }
    }

    // Cria um Observable$ para lidar com o event de *resize* da window. Decidi fazer dessa forma porque eu queria add um debounceTime() para evitar chamar a função a cada milésimo de resize e um map() pra retornar somente a width & height. A ideia por trás dessa função é notificar todos os componentes que precisam fazer ajustes na versão mobile. Será necessário fazer o .subscribe do $ dentro do componente que for utilizar.
    private listenWindowResizeEvent = () => {
        fromEvent(window, 'resize').pipe(
            debounceTime(300),
            map(() => {
                const { innerWidth, innerHeight } = window;
                return { innerWidth, innerHeight };
            })
        ).subscribe(sizes => {
            this.currentInnerWidth = sizes.innerWidth;
            this.verificaRecolheItensMenu();

            // IS MOBILE
            this.utilsService.isMobile = this.utilsService.checkIsMobile();
            this.utilsService.isSmall = this.utilsService.checkIsSmall();
            this.utilsService.isNotebook = this.utilsService.checkIsNotebook();
            this.notifyApplicationUserEnteredMobile(this.utilsService.checkIsMobile())
            this.notifyApplicationUserEnteredSmall(this.utilsService.checkIsSmall())
            this.notifyApplicationUserEnteredNotebook(this.utilsService.checkIsNotebook())
        })
    }

    private notifyApplicationUserEnteredMobile = (isMobile: boolean) => {
        if (isMobile !== this.utilsService.isMobile$.value) {
            this.utilsService.isMobile$.next(isMobile);
        }
    }

    private notifyApplicationUserEnteredSmall = (isSmall: boolean) => {
        if (isSmall !== this.utilsService.isSmall$.value) {
            this.utilsService.isSmall$.next(isSmall);
        }
    }

    private notifyApplicationUserEnteredNotebook = (isNotebook: boolean) => {
        if (isNotebook !== this.utilsService.isNotebook$.value) {
            this.utilsService.isNotebook$.next(isNotebook);
        }
    }

    verificaRecolheItensMenu() {
        this.escondeIconesMenu = false;
        if (this.currentInnerWidth <= 575) {
            this.recolheItensMenu = this.buscaAtiva ? true : false;
        } else if (this.currentInnerWidth <= 991) {
            this.recolheItensMenu = false;
        } else if (this.currentInnerWidth <= 1390) {
            this.recolheItensMenu = true;
            this.escondeIconesMenu = this.buscaAtiva ? true : false;
        } else if (this.currentInnerWidth <= 1540) {
            this.recolheItensMenu = this.extensaoInstalada && this.buscaAtiva ? false : true;
        } else {
            this.recolheItensMenu = this.buscaAtiva ? true : false;
        }
    }

    setaTituloPaginaAtual(novoTitulo) {
        try {
            let rota = this.encontraRota(this.rotaAtual);
            if (rota) this.toolBarActionsConfigs[rota].titulo = novoTitulo;
        } catch (error) {
            return false;
        }
    }

    openLink(event: Event) {
        event.preventDefault();
    }

    closeFilter() {
        this.menusService.open = false;
        this.menusService.setMenuFilter({ open: false, page: this.filtro.page })
    }

}
